module.exports = __webpack_public_path__ + "static/media/miscellaneous_food_category_GC@3x.7e3e47e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/miscellaneous_food_category_GC@3x.png
// module id = 670
// module chunks = 1